'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _bluebird = require('bluebird');

var _bluebird2 = _interopRequireDefault(_bluebird);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _matrixJsSdk = require('matrix-js-sdk');

var _CommandProvider = require('./CommandProvider');

var _CommandProvider2 = _interopRequireDefault(_CommandProvider);

var _CommunityProvider = require('./CommunityProvider');

var _CommunityProvider2 = _interopRequireDefault(_CommunityProvider);

var _DuckDuckGoProvider = require('./DuckDuckGoProvider');

var _DuckDuckGoProvider2 = _interopRequireDefault(_DuckDuckGoProvider);

var _RoomProvider = require('./RoomProvider');

var _RoomProvider2 = _interopRequireDefault(_RoomProvider);

var _UserProvider = require('./UserProvider');

var _UserProvider2 = _interopRequireDefault(_UserProvider);

var _EmojiProvider = require('./EmojiProvider');

var _EmojiProvider2 = _interopRequireDefault(_EmojiProvider);

var _NotifProvider = require('./NotifProvider');

var _NotifProvider2 = _interopRequireDefault(_NotifProvider);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
Copyright 2016 Aviral Dasgupta
Copyright 2017, 2018 New Vector Ltd

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/

var PROVIDERS = [_UserProvider2.default, _RoomProvider2.default, _EmojiProvider2.default, _NotifProvider2.default, _CommandProvider2.default, _CommunityProvider2.default, _DuckDuckGoProvider2.default];

// Providers will get rejected if they take longer than this.
var PROVIDER_COMPLETION_TIMEOUT = 3000;

var Autocompleter = function () {
    function Autocompleter(room) {
        (0, _classCallCheck3.default)(this, Autocompleter);

        this.room = room;
        this.providers = PROVIDERS.map(function (Prov) {
            return new Prov(room);
        });
    }

    (0, _createClass3.default)(Autocompleter, [{
        key: 'destroy',
        value: function destroy() {
            this.providers.forEach(function (p) {
                p.destroy();
            });
        }
    }, {
        key: 'getCompletions',
        value: function () {
            var _ref = (0, _bluebird.coroutine)( /*#__PURE__*/_regenerator2.default.mark(function _callee(query, selection) {
                var _this = this;

                var force = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
                var completionsList;
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return (0, _bluebird.resolve)(_bluebird2.default.all(
                                // Array of inspections of promises that might timeout. Instead of allowing a
                                // single timeout to reject the Promise.all, reflect each one and once they've all
                                // settled, filter for the fulfilled ones
                                this.providers.map(function (provider) {
                                    return provider.getCompletions(query, selection, force).timeout(PROVIDER_COMPLETION_TIMEOUT).reflect();
                                })));

                            case 2:
                                completionsList = _context.sent;
                                return _context.abrupt('return', completionsList.filter(function (inspection) {
                                    return inspection.isFulfilled();
                                }).map(function (completionsState, i) {
                                    return {
                                        completions: completionsState.value(),
                                        provider: _this.providers[i],

                                        /* the currently matched "command" the completer tried to complete
                                         * we pass this through so that Autocomplete can figure out when to
                                         * re-show itself once hidden.
                                         */
                                        command: _this.providers[i].getCurrentCommand(query, selection, force)
                                    };
                                }));

                            case 4:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function getCompletions(_x, _x2, _x3) {
                return _ref.apply(this, arguments);
            }

            return getCompletions;
        }()
    }]);
    return Autocompleter;
}();

exports.default = Autocompleter;
module.exports = exports['default'];
//# sourceMappingURL=Autocompleter.js.map